import { createContext, useContext, useCallback, useRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const I18nContext = /*#__PURE__*/createContext(undefined);
export function I18nContextProvider({
  children,
  value: i18nProvider
}) {
  const cache = useRef({});
  const register = useCallback(lang => {
    const registry = cache.current;
    if (!(registry[lang.source] instanceof Promise)) {
      registry[lang.source] = i18nProvider.register(lang);
    }
    return registry[lang.source];
  }, [i18nProvider]);
  return /*#__PURE__*/_jsx(I18nContext.Provider, {
    value: Object.assign({}, i18nProvider, {
      register
    }),
    children: children
  });
}
export function useI18nContext() {
  const i18nContext = useContext(I18nContext);
  if (!i18nContext) {
    throw new Error('I18nContext must be provided with a value');
  }
  return i18nContext;
}